import React from 'react';

// constellation
import { IconClose, IconMenu } from '@zillow/constellation';

// styles
import { StyledMenu } from './style';

interface Props {
  isExpanded: boolean;
  handleToggle: (arg0: boolean) => void;
}

const MenuIcon = ({ isExpanded, handleToggle }: Props) => {
  return (
    <div role="button" aria-label="menu" className="MenuIcon" onClick={() => handleToggle(!isExpanded)}>
      {isExpanded ? (
        <StyledMenu isIconClose>
          <IconClose />
        </StyledMenu>
      ) : (
        <StyledMenu isIconClose={false}>
          <IconMenu />
        </StyledMenu>
      )}
    </div>
  );
};

export default MenuIcon;
